'use client';
import * as S from './styles.ts';
import { CSSProperties } from 'react';

const ArchStandaloneSectionComponent = ({
  color = 'grey',
  background,
  withPadding,
  flip,
  style,
}: {
  color?: 'white' | 'grey' | 'dark';
  background?: 'dark' | 'grey';
  withPadding?: boolean;
  flip?: boolean;
  style?: CSSProperties;
}) => {
  return (
    <S.ArchStandaloneSectionWrapper
      $background={background}
      $withPadding={withPadding}
      style={
        flip
          ? {
              transform: 'rotate(180deg)',
              ...style,
            }
          : style
      }
    >
      <S.Arch $color={color} />
    </S.ArchStandaloneSectionWrapper>
  );
};

export default ArchStandaloneSectionComponent;

export const options = [
  {
    description: '',
    displayName: 'ArchStandaloneSectionComponent',
    methods: [],
    props: {
      color: {
        required: true,
        flowType: {
          name: 'union',
          raw: '"white" | "grey"',
          elements: [
            { name: 'literal', value: '"white"' },
            { name: 'literal', value: '"grey"' },
          ],
        },
        description: '',
      },
      background: {
        required: false,
        flowType: {
          name: 'union',
          raw: '"dark" | "grey"',
          elements: [
            { name: 'literal', value: '"dark"' },
            { name: 'literal', value: '"grey"' },
          ],
        },
        description: '',
      },
      withPadding: {
        required: false,
        flowType: { name: 'boolean' },
        description: '',
      },
    },
  },
];
